import i18n from "i18next";

// Traduction avec repli sur le texte français d'origine (clé absente = texte inchangé)
export const tr = (key, fallback) => i18n.t(key, { defaultValue: fallback });
